/* tslint:disable */
/* eslint-disable */
/**
 * Risk Management System API
 * Risk Management System API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    ApiFeature,
    ApiFeatureFromJSON,
    ApiFeatureToJSON,
    ApiOrganisation,
    ApiOrganisationFromJSON,
    ApiOrganisationToJSON,
    ApiOrganisationDataType,
    ApiOrganisationDataTypeFromJSON,
    ApiOrganisationDataTypeToJSON,
    OrganisationsPage,
    OrganisationsPageFromJSON,
    OrganisationsPageToJSON,
} from '../models';

export interface ActivateOrganisationRequest {
    organisationId: number;
}

export interface AddFeatureRequest {
    apiFeature: ApiFeature;
}

export interface AddOrganisationRequest {
    apiOrganisation: ApiOrganisation;
    demo?: boolean;
}

export interface DeactivateOrganisationRequest {
    organisationId: number;
}

export interface DeleteFeatureByNameAndOrgIdRequest {
    featureName: string;
    organisationId: number;
}

export interface DeleteOrganisationDataRequest {
    organisationId: number;
    dataType: ApiOrganisationDataType;
}

export interface FindAllOrganisationFeaturesRequest {
    organisationId?: number;
}

export interface FindAllOrganisationsRequest {
    page?: number;
    size?: number;
    includeInactive?: boolean;
    query?: string;
}

export interface UpdateOrganisationRequest {
    apiOrganisation: ApiOrganisation;
}

/**
 * 
 */
export class OrganisationApi extends runtime.BaseAPI {

    /**
     * Activates organisation
     */
    async activateOrganisationRaw(requestParameters: ActivateOrganisationRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<ApiOrganisation>> {
        if (requestParameters.organisationId === null || requestParameters.organisationId === undefined) {
            throw new runtime.RequiredError('organisationId','Required parameter requestParameters.organisationId was null or undefined when calling activateOrganisation.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["read", "write"]);
        }

        const response = await this.request({
            path: `/v1/organisations/{organisationId}/active`.replace(`{${"organisationId"}}`, encodeURIComponent(String(requestParameters.organisationId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ApiOrganisationFromJSON(jsonValue));
    }

    /**
     * Activates organisation
     */
    async activateOrganisation(requestParameters: ActivateOrganisationRequest, initOverrides?: RequestInit): Promise<ApiOrganisation> {
        const response = await this.activateOrganisationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates new feature
     */
    async addFeatureRaw(requestParameters: AddFeatureRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<ApiFeature>> {
        if (requestParameters.apiFeature === null || requestParameters.apiFeature === undefined) {
            throw new runtime.RequiredError('apiFeature','Required parameter requestParameters.apiFeature was null or undefined when calling addFeature.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["read", "write"]);
        }

        const response = await this.request({
            path: `/v1/features`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ApiFeatureToJSON(requestParameters.apiFeature),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ApiFeatureFromJSON(jsonValue));
    }

    /**
     * Creates new feature
     */
    async addFeature(requestParameters: AddFeatureRequest, initOverrides?: RequestInit): Promise<ApiFeature> {
        const response = await this.addFeatureRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates new organisation
     */
    async addOrganisationRaw(requestParameters: AddOrganisationRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<ApiOrganisation>> {
        if (requestParameters.apiOrganisation === null || requestParameters.apiOrganisation === undefined) {
            throw new runtime.RequiredError('apiOrganisation','Required parameter requestParameters.apiOrganisation was null or undefined when calling addOrganisation.');
        }

        const queryParameters: any = {};

        if (requestParameters.demo !== undefined) {
            queryParameters['demo'] = requestParameters.demo;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["read", "write"]);
        }

        const response = await this.request({
            path: `/v1/organisations`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ApiOrganisationToJSON(requestParameters.apiOrganisation),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ApiOrganisationFromJSON(jsonValue));
    }

    /**
     * Creates new organisation
     */
    async addOrganisation(requestParameters: AddOrganisationRequest, initOverrides?: RequestInit): Promise<ApiOrganisation> {
        const response = await this.addOrganisationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Deactivate organisation
     */
    async deactivateOrganisationRaw(requestParameters: DeactivateOrganisationRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<ApiOrganisation>> {
        if (requestParameters.organisationId === null || requestParameters.organisationId === undefined) {
            throw new runtime.RequiredError('organisationId','Required parameter requestParameters.organisationId was null or undefined when calling deactivateOrganisation.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["read", "write"]);
        }

        const response = await this.request({
            path: `/v1/organisations/{organisationId}/active`.replace(`{${"organisationId"}}`, encodeURIComponent(String(requestParameters.organisationId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ApiOrganisationFromJSON(jsonValue));
    }

    /**
     * Deactivate organisation
     */
    async deactivateOrganisation(requestParameters: DeactivateOrganisationRequest, initOverrides?: RequestInit): Promise<ApiOrganisation> {
        const response = await this.deactivateOrganisationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Deletes feature
     */
    async deleteFeatureByNameAndOrgIdRaw(requestParameters: DeleteFeatureByNameAndOrgIdRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.featureName === null || requestParameters.featureName === undefined) {
            throw new runtime.RequiredError('featureName','Required parameter requestParameters.featureName was null or undefined when calling deleteFeatureByNameAndOrgId.');
        }

        if (requestParameters.organisationId === null || requestParameters.organisationId === undefined) {
            throw new runtime.RequiredError('organisationId','Required parameter requestParameters.organisationId was null or undefined when calling deleteFeatureByNameAndOrgId.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["read", "write"]);
        }

        const response = await this.request({
            path: `/v1/features/{featureName}/organisation/{organisationId}`.replace(`{${"featureName"}}`, encodeURIComponent(String(requestParameters.featureName))).replace(`{${"organisationId"}}`, encodeURIComponent(String(requestParameters.organisationId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes feature
     */
    async deleteFeatureByNameAndOrgId(requestParameters: DeleteFeatureByNameAndOrgIdRequest, initOverrides?: RequestInit): Promise<void> {
        await this.deleteFeatureByNameAndOrgIdRaw(requestParameters, initOverrides);
    }

    /**
     * Delete organisation data
     */
    async deleteOrganisationDataRaw(requestParameters: DeleteOrganisationDataRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.organisationId === null || requestParameters.organisationId === undefined) {
            throw new runtime.RequiredError('organisationId','Required parameter requestParameters.organisationId was null or undefined when calling deleteOrganisationData.');
        }

        if (requestParameters.dataType === null || requestParameters.dataType === undefined) {
            throw new runtime.RequiredError('dataType','Required parameter requestParameters.dataType was null or undefined when calling deleteOrganisationData.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["read", "write"]);
        }

        const response = await this.request({
            path: `/v1/organisations/{organisationId}/data/{dataType}`.replace(`{${"organisationId"}}`, encodeURIComponent(String(requestParameters.organisationId))).replace(`{${"dataType"}}`, encodeURIComponent(String(requestParameters.dataType))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete organisation data
     */
    async deleteOrganisationData(requestParameters: DeleteOrganisationDataRequest, initOverrides?: RequestInit): Promise<void> {
        await this.deleteOrganisationDataRaw(requestParameters, initOverrides);
    }

    /**
     * Returns all organisation features
     */
    async findAllOrganisationFeaturesRaw(requestParameters: FindAllOrganisationFeaturesRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<ApiFeature>>> {
        const queryParameters: any = {};

        if (requestParameters.organisationId !== undefined) {
            queryParameters['organisationId'] = requestParameters.organisationId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["read", "write"]);
        }

        const response = await this.request({
            path: `/v1/features`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ApiFeatureFromJSON));
    }

    /**
     * Returns all organisation features
     */
    async findAllOrganisationFeatures(requestParameters: FindAllOrganisationFeaturesRequest = {}, initOverrides?: RequestInit): Promise<Array<ApiFeature>> {
        const response = await this.findAllOrganisationFeaturesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Fetches all organisations
     */
    async findAllOrganisationsRaw(requestParameters: FindAllOrganisationsRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<OrganisationsPage>> {
        const queryParameters: any = {};

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.size !== undefined) {
            queryParameters['size'] = requestParameters.size;
        }

        if (requestParameters.includeInactive !== undefined) {
            queryParameters['includeInactive'] = requestParameters.includeInactive;
        }

        if (requestParameters.query !== undefined) {
            queryParameters['query'] = requestParameters.query;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["read", "write"]);
        }

        const response = await this.request({
            path: `/v1/organisations`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OrganisationsPageFromJSON(jsonValue));
    }

    /**
     * Fetches all organisations
     */
    async findAllOrganisations(requestParameters: FindAllOrganisationsRequest = {}, initOverrides?: RequestInit): Promise<OrganisationsPage> {
        const response = await this.findAllOrganisationsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update an existing organisation
     */
    async updateOrganisationRaw(requestParameters: UpdateOrganisationRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<ApiOrganisation>> {
        if (requestParameters.apiOrganisation === null || requestParameters.apiOrganisation === undefined) {
            throw new runtime.RequiredError('apiOrganisation','Required parameter requestParameters.apiOrganisation was null or undefined when calling updateOrganisation.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["read", "write"]);
        }

        const response = await this.request({
            path: `/v1/organisations`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ApiOrganisationToJSON(requestParameters.apiOrganisation),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ApiOrganisationFromJSON(jsonValue));
    }

    /**
     * Update an existing organisation
     */
    async updateOrganisation(requestParameters: UpdateOrganisationRequest, initOverrides?: RequestInit): Promise<ApiOrganisation> {
        const response = await this.updateOrganisationRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
